import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { EdiGungMessages } from '../../../models/edi';
import { EdiMessagesListConfigService } from '../../../services/edi-messages-list-config/edi-messages-list-config.service';

@Component({
    selector: 'lib-edi-messages',
    template: '<h3 class="d-block page-title text-center" translate>EDI - Messages</h3><lib-filter-list #list [configService]="configService"></lib-filter-list>',
    standalone: false
})
export class EdiMessagesComponent implements OnInit {
  public configService = inject(EdiMessagesListConfigService);
  
  @ViewChild('list', { static: false }) list: FilterListComponent<EdiGungMessages>;


  ngOnInit() {}
}
